//
//

import { mapActions, mapGetters } from "vuex";
import columns from "./columns.js";

export default {
    data() {
        return {
            paginationControl: { rowsPerPage: 15, page: 1 },
            columns,
            filter: ""
        };
    },
    computed: {
        ...mapGetters("admin", [
            "appList",
            "loadingApps"
        ])
    },
    methods: {
        ...mapActions("admin", [
            "getAppsList",
            "removeApp",
            "installApp",
            "updateApp",
            "syncApps"
        ]),
        remove(app) {
            this.removeApp(app);
        },
        install(app) {
            console.log(app);
            this.installApp(app);
        },
        update(app) {
            this.updateApp(app);
        },
        sync() {
            this.syncApps();
        }
    },
    mounted() {
        this.getAppsList();
    }
};
